export enum CareType {
    OutOfSchoolCare = 'outOfSchoolCare',
    Daycare = 'daycare',
    Playschool = 'playschool',
    BetweenSchoolCare = 'betweenSchoolCare',
    HolidayCare = 'holidayCare',
}